import React, { useCallback } from 'react'
import ModalTitle from '@/checkout-instore-legacy/components/Commons/ModalTitle'
import Divider from '@vtex/styleguide/lib/Divider'
import { FormattedMessage } from 'react-intl'
import Button from '@vtex/styleguide/lib/Button'
import QRCode from 'qrcode.react'
import { ToastConsumer } from '@vtex/styleguide/lib/ToastProvider'
// TODO: this error popped up when moving the checkout-instore project
// to checkout-instore-legacy, but needs to be fixed at some point
// @ts-ignore
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { getIntlMessage } from '@/checkout-instore-legacy/i18n/utils'

import { shareLink } from '../service'
import { getWhatsappPaymentLink, getAbsolutePaymentLink } from '../utils'
import { NewSaleButton } from './NewSaleButton'

type SharePaymentLinkProps = {
  message: string
  shareCode: string
}

export const SharePaymentLink = ({
  shareCode,
  message,
}: SharePaymentLinkProps) => {
  const sharePaymentWhatsapp = useCallback(() => {
    shareLink(getWhatsappPaymentLink(shareCode, message))
  }, [shareCode, message])

  return (
    <div data-testId="sharePaymentLinkShow">
      <ModalTitle id="socialShareReadyLabel" />
      <Divider orientation="horizontal" />
      <div
        style={{ wordBreak: 'break-word' }}
        data-testid="shareable-message"
        className="flex flex-column pv6"
      >
        <span className="c-muted-1 f6 lh-copy">{message}</span>
      </div>

      <div
        className="flex justify-center mb7"
        data-testid="qrcode-payment-link"
      >
        <QRCode value={getAbsolutePaymentLink(shareCode)} size={200} />
      </div>

      <div className="flex items-baseline f6 mb5 ba b--light-gray br2 bw1">
        <div className="truncate ml3" data-testid="shareable-payment-link">
          {getAbsolutePaymentLink(shareCode)}
        </div>
        <div className="flex">
          <ToastConsumer>
            {({ showToast }: any) => (
              <CopyToClipboard
                text={getAbsolutePaymentLink(shareCode)}
                onCopy={() =>
                  showToast(getIntlMessage('shareCopySuccessFeedback'))
                }
              >
                <Button variation="tertiary" size="small">
                  <FormattedMessage id={'shareCopyButtonLabel'} />
                </Button>
              </CopyToClipboard>
            )}
          </ToastConsumer>
        </div>
      </div>

      <Button
        testId="share-link-button"
        variation="primary"
        onClick={() => sharePaymentWhatsapp()}
        block
      >
        <FormattedMessage id={'shareSubmitButton'} />
      </Button>

      <NewSaleButton />
    </div>
  )
}
